import React, { useState, useRef } from "react";
import { useQuery } from "react-query";
import { DataTable } from "primereact/datatable";
import authApi from "../../../service/IdApi";
import PageLoading from "../../../components/PageLoading";
import PageLoadError from "../../../components/PageLoadError";
import PageHeading from "../../../components/PageHeading";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
import { useAppContext } from "../../../context/appContext";

const AllProviders = () => {
    const { switchUnclaimedProfile } = useAppContext();
    const [providers, setProviders] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const dataTable = useRef(null);

    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 50,
        page: 1,
        sortField: "name",
        sortOrder: 1,
    });

    let params = "?first=" + lazyState.first + "&rows=" + lazyState.rows;
    if (lazyState.sortField) {
        params += "&sortField=" + lazyState.sortField;
        if (lazyState.sortOrder) {
            params += "&sortOrder=" + lazyState.sortOrder;
        }
    }

    const { isLoading, isError, data } = useQuery(["Providers", params], async () => {
        var searchBody = {};
        searchBody.first = lazyState.first;
        searchBody.rows = lazyState.rows;
        searchBody.sortField = lazyState.sortField;
        searchBody.sortOrder = lazyState.sortOrder;
        const result = await authApi.post("admin/provider/list", searchBody);
        setProviders(result.data.providers);
        setTotalRecords(result.data.totalRecords);
        setLoaded(true);
        return data;
    });

    const pageHeader = (
        <PageHeading pageTitle="Admin - All Providers">
            <div className="block">
            </div>
        </PageHeading>
    );

    if (isLoading) {
        return (
            <div>
                {pageHeader}
                <PageLoading />
            </div>
        );
    }

    if (isError) {
        return (
            <div>
                {pageHeader}
                <PageLoadError />
            </div>
        );
    }

    if (!loaded) {
        return (
            <div>
                {pageHeader}
                <PageLoading />
            </div>
        );
    }

    const onPage = (event) => {
        setlazyState(event);
    };

    const onSort = (event) => {
        setlazyState(event);
    };

    const onRowSelect = (event) => {
        // if (event.type !== "checkbox") {
        //     navigate("edit/" + event.data.itemNumber);
        // }
    };

    const exportCSV = (selectionOnly) => {
        dataTable.current.exportCSV({ selectionOnly });
    };

    const nameClicked = (e, row) => {
        e.preventDefault();
        switchUnclaimedProfile(row.name, row._id, null);
    }

    const nameBodyTemplate = (rowData) => {
        return (
            <div className="">
                <a href="#" onClick={(e) => nameClicked(e, rowData)}>{rowData.name}<span className="ml-2 pi pi-arrow-right-arrow-left" style={{ fontSize: '.8rem' }} /></a>
            </div>
        );
    };

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                {totalRecords > 0 && (
                    <div className="card pt-3 sm:pt-0">
                        <div className="flex py-3 w-full">
                            <div className="flex flex-row">
                            </div>
                            <div className="flex flex-row flex-grow-1 justify-content-end">
                                <Button type="button" icon="pi pi-file-export" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" label="Export" />
                            </div>
                        </div>
                        <DataTable
                            ref={dataTable}
                            value={providers}
                            // selection={selectedItems}
                            dataKey="_id"
                            paginator
                            rows={lazyState.rows}
                            rowsPerPageOptions={[25, 50, 100, 500]}
                            className="datatable-responsive"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} providers"
                            emptyMessage="No providers found."
                            responsiveLayout="scroll"
                            onRowSelect={onRowSelect}
                            lazy
                            first={lazyState.first}
                            totalRecords={totalRecords}
                            onPage={onPage}
                            onSort={onSort}
                            sortField={lazyState.sortField}
                            sortOrder={lazyState.sortOrder}
                            loading={isLoading || !loaded}
                        >
                            <Column body={nameBodyTemplate} field="name" header="Name" sortable />
                            <Column field="_id" header="ID" sortable />
                            <Column field="createdAt" header="Created At" sortable />
                        </DataTable>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AllProviders;
